import HStack from "shared/components/layout/stack/HStack";
import React from "react";
import { StyledFeedbackIcon } from "../custom-styles/new-edit-form/NewEditForm.styles";
import Text from "shared/components/data-display/text/Text";

const NoApproverAssinged = () => {
    return (
        <HStack spacing="Zero_25" align="flex-start">
            <StyledFeedbackIcon
                size={16}
                name={"warning"}
                color={"Yellow"}
            />
            <Text color="Black" variant="Body_2_2">
                You will not be able to submit requests for time off because you do not have a Reviewer assigned to you.
            </Text>
        </HStack>
    );
};

export default NoApproverAssinged;
